import "../Styles/Phones.css";

export const Phones = () => {
  return (
    <>
      <div className="startbox">
        <h2 className="phonetitle">SmartPhones</h2>
        &nbsp;
      </div>

      <div class="flex-container">
        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210803/1627970794478.png"
            alt="pro"
          />
          <p className="phoname">realme C2Y</p>
          <p className="sell-point">Triple Camera . Real performance</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;9,499</span>
          </div>
        </div>

        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210928/1632817235526.png"
            alt="pro"
          />
          <p className="phoname">realme C25</p>
          <p className="sell-point">Powerful Processor. 6000mAh Battery.</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;11,499</span>
          </div>
        </div>
        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210803/1627970794478.png"
            alt="pro"
          />
          <p className="phoname">realme C25Y</p>
          <p className="sell-point">50MP AI Camera. All-day Performance</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;6,499</span>
          </div>
        </div>
        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210928/1632817235526.png"
            alt="pro"
          />
          <p className="phoname">realme Narzo</p>
          <p className="sell-point">Mighty Performance Inside</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;9,499</span>
          </div>
        </div>
      </div>

      <div class="flex-container">
        <div>
          <img
            className="imphone"
            src="	https://image01.realme.net/general/20210903/1630653680914.png"
            alt="pro"
          />
          <p className="phoname">realme 8i</p>
          <p className="sell-point">120Hz. Infinitely Smooth</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;8,499</span>
          </div>
        </div>

        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210611/1623400675833.png"
            alt="pro"
          />
          <p className="phoname">realme narzo 30</p>
          <p className="sell-point">Unleash Peak Performance</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;12,499</span>
          </div>
        </div>
        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210803/1627970794478.png"
            alt="pro"
          />
          <p className="phoname">realme C2Y8</p>
          <p className="sell-point">5G. Speed to Infinity.</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;13,499</span>
          </div>
        </div>
        <div>
          <img
            className="imphone"
            src="https://image01.realme.net/general/20210506/1620287407432.png"
            alt="pro"
          />
          <p className="phoname">realme C2Y</p>
          <p className="sell-point">Triple Camera . Real performance</p>

          <div className="plate-normal-price">
            <span className="price-from">From </span>

            <span className="redd"> ₹&nbsp;9,499</span>
          </div>
        </div>
      </div>

      <div >
        <h2 className="phonetitle">Smart Life</h2>
        <div class="flex-container">
          <div className="boxflexs">
            <div className="boxfle1">
              <p className="stic">realme Smart TV Stick</p>

              <p className="goog">
                New Google TV Platform | 4Kp60 AV1 Encoding
              </p>
              <span className="redd"> ₹&nbsp;9,499</span>
            </div>
            <div className="boxfle2">
              <img
                alt="piic"
                className="fleimg"
                src="https://image01.realme.net/general/20211201/1638346373432.jpg"
              />
            </div>
          </div>
          <div className="boxflexs">
            <div className="boxflexs">
              <div className="boxfle1">
                <p className="stic">realme TechLife Air Purifier</p>

                <p className="goog"> Breathe Better, Live Better</p>
                <span className="redd"> ₹&nbsp;7,499</span>
              </div>
              <div className="boxfle2">
                <img
                  alt="piic"
                  className="fleimg"
                  src="	https://image01.realme.net/general/20210927/1632727127886.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="flex-container">
          <div className="boxflexs">
            <div className="boxfle1">
              <p className="stic">realme Watch 2 Pro</p>

              <p className="goog">Big Display.Pro Sports.</p>
              <span className="redd"> ₹&nbsp;4,499</span>
            </div>
            <div className="boxfle2">
              <img
                alt="piic"
                className="fleimg"
                src="	https://image01.realme.net/general/20210819/1629373840520.jpg"
              />
            </div>
          </div>
          <div className="boxflexs">
            <div className="boxflexs">
              <div className="boxfle1">
                <p className="stic">realme smart TV Neo</p>

                <p className="goog">SMARTER IS BETTER</p>
                <span className="redd"> ₹&nbsp;17,499</span>
              </div>
              <div className="boxfle2">
                <img
                  alt="piic"
                  className="fleimg"
                  src="	https://image01.realme.net/general/20210927/1632736298242.jpg"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="flex-container">
          <div>
            <img
              className="imphone"
              src="https://image01.realme.net/general/20210907/1630992241023.png"
              alt="pro"
            />
            <p className="phoname">realme Pad</p>
            <p className="sell-point">ultra slim</p>

            <div className="plate-normal-price">
              <span className="price-from">From </span>

              <span className="redd"> ₹&nbsp;18,499</span>
            </div>
          </div>

          <div>
            <img
              className="imphone"
              src="	https://image01.realme.net/general/20210812/1628766763084.png"
              alt="pro"
            />
            <p className="phoname">realme Book</p>
            <p className="sell-point">Designed Performance</p>

            <div className="plate-normal-price">
              <span className="price-from">From </span>

              <span className="redd"> ₹&nbsp;42,499</span>
            </div>
          </div>
          <div>
            <img
              className="imphone"
              src="https://image01.realme.net/general/20210531/1622446151388.png"
              alt="pro"
            />
            <p className="phoname">realme Stark TV</p>
            <p className="sell-point">5G. Speed to Infinity.</p>

            <div className="plate-normal-price">
              <span className="price-from">From </span>

              <span className="redd"> ₹&nbsp;23,499</span>
            </div>
          </div>
          <div>
            <img
              className="imphone"
              src="https://image01.realme.net/general/20211201/1638356645950.png"
              alt="pro"
            />
            <p className="phoname">realme watch</p>
            <p className="sell-point">Triple Camera . Real performance</p>

            <div className="plate-normal-price">
              <span className="price-from">From </span>
              <span className="redd"> ₹&nbsp;2,499</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Phones;
